export const getStatusStyles = (status) => {
    const normalizedStatus = status?.toLowerCase();
  
    const icons = {
      pending: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <circle cx="9" cy="9" r="7.5" stroke="#F9933D" stroke-width="1.5"/>
          <path d="M9 6V9L10.5 10.5" stroke="#F9933D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="18" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>`,
      scheduled: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <circle cx="9" cy="9" r="7.5" stroke="#1C5DBC" stroke-width="1.5"/>
          <path d="M9 6V9L10.5 10.5" stroke="#1C5DBC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="18" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>`,
      expired: `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.5 5.5V8.5M8.51344 11.5H8.5M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z" stroke="#E52227" stroke-width="1.5" stroke-linecap="round"/>
      </svg>`,
      completed: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9Z" stroke="#3FB65D" stroke-width="1.5"/>
          <path d="M6 9.5625C6 9.5625 7.2 10.2469 7.8 11.25C7.8 11.25 9.6 7.3125 12 6" stroke="#3FB65D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="18" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>`
      
    };
  
    switch (normalizedStatus) {
        case "to be signed":
        case "pending":
        case "Pending":
            return {
                color: "#F9933D",
                backgroundColor: "#FFF4EA",
                icon: icons.pending
            };
        case "scheduled":
            return {
                color: "#1C5DBC",
                backgroundColor: "#E3F2FD",
                icon: icons.scheduled
            };
        case "expired":
            return {
                color: "#E52227",
                backgroundColor: "#FFEBEE",
                icon: icons.expired
            };
        case "failed":
            return {
                color: "#FF5959",
                backgroundColor: "#FFEEEE",
            };
        case "Completed":
        case "completed":
            return {
                color: "#3FB65D",
                backgroundColor: "#E8F5E9",
                icon: icons.completed
            };
        default:
            return {
                color: "#1D1D1D",
                backgroundColor: "#F5F5F5"
            };
    }
  };
  